import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { getPublicNoticeCircular } from "../../../helper/Api";
import {
  isNoticeEnabled,
  noticeHtmlHasText,
  sanitizeNoticeHtml,
} from "../../../helper/noticeCircular";
import "./NoticeCircularModal.css";

const NoticeCircularModal = () => {
  const [open, setOpen] = useState(false);
  const [messageHtml, setMessageHtml] = useState("");

  useEffect(() => {
    let cancelled = false;

    getPublicNoticeCircular()
      .then((response) => {
        if (cancelled) return;
        const data = response?.data?.data || response?.data?.result || {};
        const message = sanitizeNoticeHtml(data.message);
        if (isNoticeEnabled(data.is_enabled) && noticeHtmlHasText(message)) {
          setMessageHtml(message);
          setOpen(true);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  if (!open) return null;

  return (
    <div className="notice-circular-modal" role="dialog" aria-modal="true" aria-label="Notice circular">
      <div className="notice-circular-modal__card">
        <div className="notice-circular-modal__header">
          <span className="notice-circular-modal__pulse" aria-hidden="true" />
          <h2 className="notice-circular-modal__title">Notice Circular</h2>
          <button
            type="button"
            className="notice-circular-modal__close"
            aria-label="Close notice"
            onClick={() => setOpen(false)}
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
        <div
          className="notice-circular-modal__body"
          dangerouslySetInnerHTML={{ __html: messageHtml }}
        />
      </div>
    </div>
  );
};

export default NoticeCircularModal;
